import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {CaseCategory, SaveCaseCategory} from "../models/case-category";

@Injectable({
  providedIn: 'root'
})
export class CaseCategoryService {

  constructor(private httpClient: HttpClient) {}

  getCaseCategories(includeInactive = false): Observable<CaseCategory[]> {
    return this.httpClient.get<CaseCategory[]>(
      `${environment.apiUrl}/api/case-categories`,
      {params: {includeInactive}}
    );
  }

  createCaseCategory(category: SaveCaseCategory): Observable<{value: string}> {
    return this.httpClient.post<{value: string}>(`${environment.apiUrl}/api/case-categories`, category);
  }

  updateCaseCategory(category: SaveCaseCategory): Observable<void> {
    return this.httpClient.put<void>(`${environment.apiUrl}/api/case-categories/${category.id}`, category);
  }
}
